import React from 'react';
import './Snowfall.css';

// SVG paths for religious symbols - consistent across all devices
const StarOfDavid: React.FC<{ size: number; color: string }> = ({ size, color }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L15.09 8H20.18L17.09 12L20.18 16H15.09L12 22L8.91 16H3.82L6.91 12L3.82 8H8.91L12 2Z" 
              fill={color} fillOpacity="0.9" />
    </svg>
);

const Cross: React.FC<{ size: number; color: string }> = ({ size, color }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2H14V8H20V12H14V22H10V12H4V8H10V2Z" 
              fill={color} fillOpacity="0.9" />
    </svg>
);

const CrescentStar: React.FC<{ size: number; color: string }> = ({ size, color }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C13.82 22 15.53 21.51 17 20.65C13.7 19.32 11.36 16.04 11.36 12.22C11.36 8.22 13.88 4.82 17.4 3.6C15.76 2.58 13.95 2 12 2Z" 
              fill={color} fillOpacity="0.9" />
        <path d="M19 7L19.94 9.06L22 10L19.94 10.94L19 13L18.06 10.94L16 10L18.06 9.06L19 7Z" 
              fill={color} fillOpacity="0.9" />
    </svg>
);

const symbols = [StarOfDavid, Cross, CrescentStar];

const Snowfall: React.FC = () => {
    const snowflakes = Array.from({ length: 60 });

    return (
        <div className="snowfall-container">
            {snowflakes.map((_, index) => {
                const SymbolComponent = symbols[Math.floor(Math.random() * symbols.length)];
                const duration = Math.random() * 10 + 10;
                const delay = Math.random() * 10;
                const size = Math.random() * 12 + 10;
                const isGold = Math.random() > 0.8;
                const color = isGold ? '#FFD700' : '#FFFFFF';

                return (
                    <div
                        key={index}
                        className="snowflake-wrapper"
                        style={{
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${delay}s`,
                            animationDuration: `${duration}s`,
                        }}
                    >
                        <div
                            className="snowflake-inner"
                            style={{
                                animationDelay: `${delay}s`,
                                animationDuration: `${Math.random() * 4 + 3}s`,
                                opacity: Math.random() * 0.5 + 0.3,
                                filter: isGold 
                                    ? 'drop-shadow(0 0 6px rgba(255, 215, 0, 0.6))' 
                                    : 'drop-shadow(0 0 4px rgba(255, 255, 255, 0.4))',
                            }}
                        >
                            <SymbolComponent size={size} color={color} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Snowfall;
